<script>
	import PersonalDetails from "./PersonalDetails.svelte";
	import HoldingsAndTrades from "./HoldingsAndTrades.svelte";
	import DocumentUpload from "./DocumentUpload.svelte";

	import { projectSettings } from "../../config";
	import { pageNumber } from "../../stores";

	export let pageIndex = null;

	let disabled = true;

	pageNumber.update((p) => pageIndex);

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<h1>Nuix Shareholder Class Action Registration</h1>

	<PersonalDetails {disabled}></PersonalDetails>
	<HoldingsAndTrades {disabled}></HoldingsAndTrades>
	<DocumentUpload {disabled}></DocumentUpload>
</section>
